module.exports = __webpack_public_path__ + "img/elitePlayers.bf0cf576.svg";